export default "__VITE_ASSET__BkHkxiOA__"